import React from "react";
import VeltCommentDialogAssigneeBannerResolveButton from "./VeltCommentDialogAssigneeBannerResolveButton/VeltCommentDialogAssigneeBannerResolveButton";
import VeltCommentDialogAssigneeBannerUserAvatar from "./VeltCommentDialogAssigneeBannerUserAvatar/VeltCommentDialogAssigneeBannerUserAvatar";
import VeltCommentDialogAssigneeBannerUserName from "./VeltCommentDialogAssigneeBannerUserName/VeltCommentDialogAssigneeBannerUserName";
var VeltCommentDialogAssigneeBanner = function (props) {
    var children = props.children;
    return (React.createElement("velt-comment-dialog-assignee-banner-wireframe", null, children));
};
VeltCommentDialogAssigneeBanner.ResolveButton = VeltCommentDialogAssigneeBannerResolveButton;
VeltCommentDialogAssigneeBanner.UserAvatar = VeltCommentDialogAssigneeBannerUserAvatar;
VeltCommentDialogAssigneeBanner.UserName = VeltCommentDialogAssigneeBannerUserName;
export default VeltCommentDialogAssigneeBanner;
